import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { Workspace, WorkspaceCreatePayload } from "@/lib/types";

export function useCreateWorkspace() {
  const qc = useQueryClient();
  return useMutation<Workspace, Error, WorkspaceCreatePayload>({
    mutationFn: (payload) => api.createWorkspace(payload),
    onSuccess: (workspace) => {
      qc.setQueryData<Workspace[]>(queryKeys.workspaces, (prev) =>
        prev ? [workspace, ...prev] : [workspace],
      );
      void qc.invalidateQueries({ queryKey: queryKeys.workspaces });
    },
  });
}
